import { createClient } from 'laboratory-lib';
import { TREATMENTS_EARLY_REQUEST_KEY } from '../early-requester/bulk-experiments-request/makeBulkTreatmentsEarlyRequest';
import { getPortalId } from '../store/auth/selectors';
import { experimentsEnabled } from './ExperimentUtils';
import { getExperimentsConfig } from './getExperimentsConfig';
import { getUserExperimentIdentifier } from './getUserExperimentIdentifier';
export const getTreatmentsClient = ({
  identifier = getUserExperimentIdentifier()
} = {}) => {
  return createClient({
    ceid: identifier,
    timeout: 8000,
    quickFetchLabel: TREATMENTS_EARLY_REQUEST_KEY,
    experiments: getExperimentsConfig(),
    identifiers: {
      utk: getUserExperimentIdentifier(),
      portalId: null
    },
    // if the experiments are disabled, we want to get default treatments back from laboratory
    mode: experimentsEnabled() ? 'default' : 'cache-only'
  });
};
export const getPortalIdTreatmentsClient = state => {
  return createClient({
    timeout: 3000,
    experiments: getExperimentsConfig(),
    identifiers: {
      portalId: getPortalId(state),
      utk: null
    }
  });
};